import { ObjectConfig } from "@homebound/form-state";
import { ChangeEventWorkflow } from "src/generated/graphqlTypes";
import {
  baseChangeEventFormConfig,
  BaseChangeEventFormInput,
} from "src/routes/projects/change-events/guided/baseChangeEventForm";
import { GuidedChangeEventConfigType, GuidedChangeEventStep } from "src/routes/projects/change-events/guided/utils";
import {
  NotInPrototypeYet,
  reviewImpactStep,
  reviewStep,
} from "src/routes/projects/change-events/guided/workflows/sharedSteps/sharedSteps";
import { defineWorkflow } from "src/routes/projects/change-events/guided/workflows/types";
import { SelectConfigurationStep } from "../1.SelectConfigurationStep";
import { ApplyInitialConfigurationGate } from "./components/ApplyInitialConfigurationGate";

export type ApplyConfigurationFormInput = BaseChangeEventFormInput & {
  selectedConfigType?: GuidedChangeEventConfigType | null;
  selectedConfigId?: string | null;
};

const formConfig: ObjectConfig<ApplyConfigurationFormInput> = {
  ...baseChangeEventFormConfig,
  selectedConfigType: { type: "value" },
  selectedConfigId: { type: "value" },
};

export const applyInitialConfigurationWorkflow = defineWorkflow<ApplyConfigurationFormInput>({
  workflow: ChangeEventWorkflow.ApplyInitialConfiguration,
  formConfig,
  gate: (props) => <ApplyInitialConfigurationGate {...props} />,
  steps: [
    {
      value: GuidedChangeEventStep.SelectConfiguration,
      label: "Select Configuration",
      isComplete: (form) => !!form.selectedConfigId.value,
      render: (form) => <SelectConfigurationStep formState={form} />,
    },
    {
      value: GuidedChangeEventStep.ReviewConfiguration,
      label: "Review Configuration",
      isComplete: () => false,
      disabled: (form) => !form.selectedConfigId.value,
      render: () => <NotInPrototypeYet title="Review Configuration" />,
    },
    reviewImpactStep(),
    reviewStep(),
  ],
  useActions: () => {
    return {
      // TODO: submit the change event for the apply-initial-configuration flow.
      onSubmit: async () => {},
    };
  },
});
